import lessonsApi from '@/api/lessons';

const actions = {
  FETCH_SHARE_HISTORY: async ({ commit, dispatch, state, rootGetters }) => {
    const { id: userId } = rootGetters.userProfile;

    if (!userId) {
      return;
    }

    const { currentPage, dateRange, searchKeyword, filters } = state;
    const { start, end } = dateRange;

    const params = {
      page: currentPage + 1,
      start_date: start,
      end_date: end,
      ...(searchKeyword ? { search: searchKeyword } : {}),
      ...filters,
    };

    dispatch('wait/start', 'shareHistory.fetching', { root: true });

    try {
      const { results: history } = await lessonsApi.fetchShareHistory(userId, params);

      commit('SET_HISTORY', history);
      commit('SET_REFRESH_DATE', Date.now());
    } finally {
      dispatch('wait/end', 'shareHistory.fetching', { root: true });
    }
  },

  CHANGE_CURRENT_PAGE: ({ commit, dispatch }, { currentPage }) => {
    commit('SET_CURRENT_PAGE', currentPage);
    dispatch('FETCH_SHARE_HISTORY');
  },

  CANCEL_ASSIGNMENT: async ({ commit, dispatch }, assignmentId) => {
    dispatch('wait/start', 'shareHistory.canceling', { root: true });

    try {
      const { id, status } = await lessonsApi.cancelSharedLesson(assignmentId);

      commit('CANCEL_ASSIGNMENTS', { id, status });
    } finally {
      dispatch('wait/end', 'shareHistory.canceling', { root: true });
    }
  },

  DATE_RANGE_UPDATE: ({ commit, dispatch }, dateRange) => {
    commit('SET_DATE_RANGE', dateRange);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_SHARE_HISTORY');
  },

  SEARCH_BY_KEYWORD: ({ commit, dispatch }) => {
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_SHARE_HISTORY');
  },

  APPLY_FILTER: ({ commit, dispatch }, filter) => {
    commit('SET_FILTER', filter);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_SHARE_HISTORY');
  },

  REMOVE_FILTER: ({ commit, dispatch }, key) => {
    commit('DELETE_FILTER', key);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_SHARE_HISTORY');
  },

  RESET_FILTERS: ({ commit, dispatch, state }) => {
    if (Object.keys(state.filters).length === 0) {
      return;
    }
    commit('RESET_FILTERS');
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_SHARE_HISTORY');
  },
};

export default actions;
